export interface RenderStyle {
  id: string;
  name: string;
  description: string;
}

export const renderStyles: RenderStyle[] = [
  {
    id: "cinematic",
    name: "Cinematic Realism",
    description: "High-quality photorealistic renders that resemble movie stills with dramatic lighting and composition."
  },
  // {
  //   id: "wes-anderson",
  //   name: "Wes Anderson-esque",
  //   description: "Symmetrical compositions, pastel colors, and whimsical set designs in the style of Wes Anderson films."
  // },
  {
    id: "noir",
    name: "Gritty Noir",
    description: "High contrast black and white visuals with dramatic shadows and moody lighting for detective stories and thrillers."
  },
  {
    id: "ghibli",
    name: "Anime",
    description: "Soft, painterly visuals inspired by the magical worlds and character designs of the anime genre."
  },
  {
    id: "comic",
    name: "Comic Book",
    description: "Bold outlines, vibrant colors, and dynamic compositions that resemble comic book panels."
  },
  {
    id: "surreal",
    name: "Surrealism",
    description: "Dreamlike and fantastical visuals that combine unexpected elements and break the rules of reality."
  },
  {
    id: "documentary",
    name: "Documentary",
    description: "Natural lighting and realistic compositions that mimic documentary filmmaking with a focus on realism."
  },
  // {
  //   id: "sitcom",
  //   name: "90s Sitcom Style",
  //   description: "Bright, flat lighting and standard multi-camera setups reminiscent of classic television sitcoms."
  // }
];

export function getStyleById(id: string): RenderStyle | undefined {
  return renderStyles.find(style => style.id === id);
}

export function getStyleByName(name: string): RenderStyle | undefined {
  return renderStyles.find(style => style.name === name);
}
